import { observer } from 'mobx-react-lite'
import { FC } from 'react'

const Operators: FC = observer(() => <div>Operators</div>)

export default Operators
